module.exports = __webpack_public_path__ + "img/law4m-m@2.a99f7ba0.jpg";